import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import { toast } from "react-toastify";
import { grantSpAccess, updateOnboardingState } from "~/api/v2/requests";

type Props = {
  onSubmit: () => void;
};

export const GrantAccessStep = ({ onSubmit }: Props) => {
  const { t } = useTranslation();

  const handleGrant = async () => {
    try {
      await grantSpAccess();
      onSubmit();
    } catch (err) {
      console.error(err);
      toast.error(t(($) => $.sharepoint.steps.grantAccess.error));
    }
  };

  const handleBack = async () => {
    await updateOnboardingState({ siteId: null, driveId: null });
    onSubmit();
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <span>{t(($) => $.sharepoint.steps.grantAccess.header)}</span>
        </CardTitle>
        <CardDescription>
          {t(($) => $.sharepoint.steps.grantAccess.subtitle)}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <p className="text-sm">
          {t(($) => $.sharepoint.steps.grantAccess.info)}
        </p>
      </CardContent>
      <CardFooter className="justify-between">
        <Button onClick={handleBack} variant="secondary">
          {t(($) => $.commons.buttons.back)}
        </Button>
        <Button onClick={handleGrant}>
          {t(($) => $.commons.buttons.proceed)}
        </Button>
      </CardFooter>
    </Card>
  );
};
